export class OnboardingKitIncludedReports {
    includePlacard = true;
    includePDC = true;
    includeBAReport = true;
}
